// Composant d'affichage lisible des réponses questionnaire pour l'espace conseiller.
// Traduction des valeurs techniques en français, sans jamais exposer submission_id
// ni les noms techniques des champs.

const LABELS = {
    position:      { dos: "Sur le dos", cote: "Sur le côté", ventre: "Sur le ventre", change: "Change souvent de position" },
    sensation:     { enveloppante: "Très enveloppante", moelleuse: "Moelleuse", equilibree: "Équilibrée",
                     tonique: "Tonique", ferme: "Ferme" },
    movement_ease: { peu: "Peu", assez: "Assez important", tres: "Très important" },
    heat:          { rarement: "Rarement", parfois: "Parfois", souvent: "Souvent", tres_souvent: "Très souvent" },
    partner:       { pas: "Pas du tout", peu: "Un peu", moyen: "Modérément", beaucoup: "Beaucoup" },
    envelopment:   { 1: "1 (ferme)", 2: "2", 3: "3 (équilibré)", 4: "4", 5: "5 (très enveloppant)" },
};

const trad = (field, val) => {
    if (val === null || val === undefined || val === "") return "—";
    if (LABELS[field]?.[val] !== undefined) return LABELS[field][val];
    if (Array.isArray(val)) return val.join(", ") || "—";
    return String(val);
};

function sleeperRows(s = {}, other) {
    return [
        ["Taille",         s.taille ? `${s.taille} cm` : "—"],
        ["Poids",          s.poids  ? `${s.poids} kg`  : "—"],
        ["Position",       trad("position",      s.position)],
        ["Sensation",      trad("sensation",     s.sensation)],
        ["Enveloppement",  trad("envelopment",   s.envelopment)],
        ["Facilité de mouvement", trad("movement_ease", s.movement_ease)],
        ["Chaleur ressentie",     trad("heat",          s.heat)],
        ["Gênes",          Array.isArray(s.discomfort_areas) ? (s.discomfort_areas.join(", ") || "—") : "—"],
        ...(other?.discomfort ? [["Précision gêne (Autre)", other.discomfort]] : []),
        ["Ressenti partenaire",  trad("partner",       s.partner)],
    ];
}

function commonRows(a = {}) {
    const rows = [
        ["Nombre de dormeurs", a.nb_sleepers === 2 ? "2 (couple)" : (a.nb_sleepers === 1 ? "1 (seul)" : "—")],
        ["Matelas actuel", a.current_mattress_type || "—"],
        ["Raisons de changement", (a.change_reasons || []).join(", ") || "—"],
    ];
    if (a.other_texts?.change_reason) rows.push(["Précision raison (Autre)", a.other_texts.change_reason]);
    rows.push(["Dimension souhaitée", a.dimension || "—"]);
    rows.push(["Budget indiqué", a.budget != null ? `${a.budget} €` : "—"]);
    if (a.budget_priority === true)  rows.push(["Priorité", "Confort d'abord, budget adaptable"]);
    if (a.budget_priority === false) rows.push(["Priorité", "Budget strict"]);
    return rows;
}

function Table({ rows, testid }) {
    return (
        <table className="w-full text-sm border border-brand-ink/10 rounded-xl overflow-hidden" data-testid={testid}>
            <thead className="bg-brand-beige/60">
                <tr>
                    <th className="text-left px-3 py-2 font-medium text-brand-ink/70 w-1/2">Question</th>
                    <th className="text-left px-3 py-2 font-medium text-brand-ink/70">Réponse</th>
                </tr>
            </thead>
            <tbody>
                {rows.map(([q, r], i) => (
                    <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-brand-beige/20"}>
                        <td className="px-3 py-2 text-brand-ink/70">{q}</td>
                        <td className="px-3 py-2 text-brand-ink">{r}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default function AnswersReadable({ answers }) {
    const a = answers || {};
    const sleepers = Array.isArray(a.sleepers) ? a.sleepers : [];
    const otherDisc = a.other_texts?.discomfort || {};

    if (sleepers.length >= 2) {
        return (
            <div className="space-y-4">
                <div>
                    <h4 className="text-sm font-medium text-brand-ink mb-2">Dormeur 1</h4>
                    <Table rows={sleeperRows(sleepers[0], { discomfort: otherDisc["0"] })} testid="answers-sleeper-1" />
                </div>
                <div>
                    <h4 className="text-sm font-medium text-brand-ink mb-2">Dormeur 2</h4>
                    <Table rows={sleeperRows(sleepers[1], { discomfort: otherDisc["1"] })} testid="answers-sleeper-2" />
                </div>
                <div>
                    <h4 className="text-sm font-medium text-brand-ink mb-2">Réponses communes</h4>
                    <Table rows={commonRows(a)} testid="answers-common" />
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-4">
            <Table rows={sleeperRows(sleepers[0] || {}, { discomfort: otherDisc["0"] })} testid="answers-sleeper-1" />
            <Table rows={commonRows(a)} testid="answers-common" />
        </div>
    );
}
